import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpService } from '../../http/http.service';

interface FiltroDocumentosSolicitudParentescoDTO {
  solicitudesTiposId: number | null;
  parentescosNombre: string | null;
  edad: number | null;
  discapacidad: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentosSolicitudService {
  constructor(private httpService: HttpService) { }

  filtrarDocumentos(filtro: FiltroDocumentosSolicitudParentescoDTO): Observable<any> {
    return this.httpService.post<any>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      '/documentos-solicitud-parentesco/filtrar',
      filtro
    ).pipe(
      timeout(25000),
      catchError(error => {
        console.error("Error en la solicitud de documentos:", error);
        return throwError(() => error);
      })
    );
  }
  
}